import type { Nullable } from "../../../../typescript"
import type { EntityId } from "../../entity/EntityId.type"

export default function toEntityId9GLSL (
  list: Array<Nullable<EntityId>>,
  entityId: Nullable<EntityId>,
) : Array<EntityId> {
  const entityIdList = [...list, entityId]

  for (let i = 0; i < 9; i++) {
    entityIdList[i] ||= (0 as EntityId)
  }

  return entityIdList as Array<EntityId>
}